module.exports = __webpack_public_path__ + "img/bay.074a20df.png";